export const upload = (prop: string) => {
    document.getElementById(prop)?.click()
}
